import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import VerificationPage from './pages/VerificationPage';
import './App.css';
import './styles/VerificationPage.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/verify" element={<VerificationPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;